export default __webpack_public_path__ + "static/media/member-layout-banner.b2a7b88e.png";